module.exports = __webpack_public_path__ + "static/fonts/D-DIN-PRO-400-Regular.9f9522e4.otf";